import { useQuery } from '@tanstack/react-query';
import { getWorkflowConfig } from '../../api/WorkflowServiceAPI';
import { queryKeys } from '../queryKeys';

export const useGetWorkflowConfig = (workflowId = '') => {
    const { data, isLoading, ...rest } = useQuery({
        queryKey: queryKeys.workflowConfig(workflowId),
        queryFn: () => getWorkflowConfig(workflowId),
        enabled: !!workflowId,
    });

    return {
        workflowConfig: data,
        isLoadingWorkflowConfig: isLoading,
        ...rest,
    };
};
